import { useTranslation } from "react-i18next";
import { Text, Tooltip } from "@chakra-ui/react";
import { getFormattedNumValue } from "../../utils";
import React from "react";

const CustomBar = ({ barItemData, dataAttribute, handleBarClick }) => {
  const { t } = useTranslation("translation");
  const { x, y, width, height, data } = barItemData;

  const totalValue = data.data.total ?? 0;
  const heightScalePercentage = totalValue !== 0 ? height / totalValue : 0;
  const scopeOneHeightInPX = Math.floor((data.data["Scope 1"] ?? 0) * heightScalePercentage);
  const scopeTwoHeightInPX = Math.floor((data.data["Scope 2"] ?? 0) * heightScalePercentage);
  const scopeThreeHeightInPX = Math.floor((data.data["Scope 3"] ?? 0) * heightScalePercentage);

  const scopeOneHeightYCoordinate = y + height - scopeOneHeightInPX;

  const scopeOneValue = data.data["Scope 1"] ?? null;
  const scopeTwoValue = data.data["Scope 2"] ?? null;
  const scopeThreeValue = data.data["Scope 3"] ?? null;

  const renderLowValueCircle = () => {
    const renderLabelContent = () => {
      const arr = [];

      if (((data.id === "Scope 1" && scopeOneValue) || (data.id === "Scope 2" && scopeTwoValue && !scopeOneValue) ||
          (data.id === "Scope 3" && scopeThreeValue && !scopeOneValue && !scopeTwoValue)) &&
        (scopeOneHeightInPX === 0 || scopeTwoHeightInPX === 0 || scopeThreeHeightInPX === 0)) {
        if (scopeOneValue && scopeOneValue > 0) {
          arr.push(<Text key="scope-1-small-value" fontSize="sm">
            {t("scope")} 1 - {data.data[dataAttribute]}: <b>{getFormattedNumValue(scopeOneValue)}</b> tCO<sub>2e</sub>
          </Text>);
        }
        if (scopeTwoValue && scopeTwoValue > 0) {
          arr.push(<Text key="scope-2-small-value" fontSize="sm">
            {t("scope")} 2 - {data.data[dataAttribute]}: <b>{getFormattedNumValue(scopeTwoValue)}</b> tCO<sub>2e</sub>
          </Text>);
        }
        if (scopeThreeValue && scopeThreeValue > 0) {
          arr.push(<Text key="scope-3-small-value" fontSize="sm">
            {t("scope")} 3 - {data.data[dataAttribute]}: <b>{getFormattedNumValue(scopeThreeValue)}</b> tCO<sub>2e</sub>
          </Text>);
        }
      }

      return arr.length > 0 ? arr : null;
    };

    return renderLabelContent() !== null ?
      <Tooltip
        key={data.data.id}
        fontSize={"sm"}
        fontWeight="normal"
        rounded={"md"}
        padding={"15px 10px"}
        bg="white"
        color="black"
        placement="auto"
        label={renderLabelContent()}
      >
        <circle
          cx={x + width / 2}
          cy={scopeOneHeightYCoordinate - scopeTwoHeightInPX - scopeThreeHeightInPX - 3}
          r="3"
          fill={"hsl(183,11%,67%)"}
          onClick={typeof handleBarClick !== "undefined" ? () => handleBarClick(data) : null}
          cursor={typeof handleBarClick !== "undefined" ? "pointer" : "auto"}
        />
      </Tooltip> : null;
  };

  return (
    <g>
      {
        ((scopeOneValue && scopeOneValue > 0 && scopeOneHeightInPX === 0) ||
          (scopeTwoValue && scopeTwoValue > 0 && scopeTwoHeightInPX === 0) ||
          (scopeThreeValue && scopeThreeValue > 0 && scopeThreeHeightInPX === 0)
        ) ?
          renderLowValueCircle() : null
      }
      {
        data.id === "Scope 1" ?
          <Tooltip
            fontSize={"sm"}
            fontWeight="normal"
            rounded={"md"}
            padding={"15px 10px"}
            bg="white"
            color="black"
            placement="auto"
            label={
              <Text fontSize="sm">
                {data.id} - {data.data[dataAttribute]}: <b>{getFormattedNumValue(scopeOneValue)}</b> tCO<sub>2e</sub>
              </Text>
            }
          >
            <rect
              fill={"hsla(50,100%,50%,0.49)"}
              height={height}
              width={width}
              x={x}
              y={y}
              onClick={typeof handleBarClick !== "undefined" ? () => handleBarClick(data) : null}
              cursor={typeof handleBarClick !== "undefined" ? "pointer" : "auto"}
            />
          </Tooltip> : null
      }
      {
        data.id === "Scope 2" ?
          <Tooltip
            fontSize={"sm"}
            fontWeight="normal"
            rounded={"md"}
            padding={"15px 10px"}
            bg="white"
            color="black"
            placement="auto"
            label={
              <Text fontSize="sm">
                {data.id} - {data.data[dataAttribute]}: <b>{getFormattedNumValue(scopeTwoValue)}</b> tCO<sub>2e</sub>
              </Text>
            }
          >
            <rect
              fill={"hsla(0,100%,50%,0.62)"}
              height={height}
              width={width}
              x={x}
              y={y}
              onClick={typeof handleBarClick !== "undefined" ? () => handleBarClick(data) : null}
              cursor={typeof handleBarClick !== "undefined" ? "pointer" : "auto"}
            />
          </Tooltip> : null
      }
      {
        data.id === "Scope 3" ?
          <Tooltip
            fontSize={"sm"}
            fontWeight="normal"
            rounded={"md"}
            padding={"15px 10px"}
            bg="white"
            color="black"
            placement="auto"
            label={
              <Text fontSize="sm">
                {data.id} - {data.data[dataAttribute]}: <b>{getFormattedNumValue(scopeThreeValue)}</b> tCO<sub>2e</sub>
              </Text>
            }
          >
            <rect
              fill={"hsla(212,100%,50%,0.75)"}
              height={height}
              width={width}
              x={x}
              y={y}
              onClick={typeof handleBarClick !== "undefined" ? () => handleBarClick(data) : null}
              cursor={typeof handleBarClick !== "undefined" ? "pointer" : "auto"}
            />
          </Tooltip> : null
      }
    </g>
  );
};

export default CustomBar;